import keyMirror from "ramda-extension/es/keyMirror";
export const actionTypes = keyMirror({
    SET_REQUEST: null,
    UPDATE_REQUEST: null,
    CLEAR_REQUEST: null,
    RESET: null
});
export const REDUCER_NAME = 'cache';
export const CACHE_KEY_PROP = 'cacheKey';
export default {
    actionTypes,
    REDUCER_NAME
};
